module.exports = __webpack_public_path__ + "static/media/md-tablet-landscape.d6746961.svg";